import { classnames } from '@aibees/shared/utils';
import { Box, Collapse } from '@mui/material';
import { memo, useCallback, useState } from 'react';
import { CURRENT_PLAN_BANNER_ID } from './config';
import { CurrentPlanHeader } from './components/current-plan-header';
import { CurrentPlanInclusion } from './components/current-plan-inclusion';
import { CurrentPlanSummary } from './components/current-plan-summary';
import { useCurrentPlan } from './hooks/use-current-plan';
import * as SX from './sx';
import type { CurrentPlanBannerProps as Props } from './types';

export const CurrentPlanBanner = memo(({ className }: Props) => {
  const { data: plan } = useCurrentPlan();
  const [open, setOpen] = useState(false);

  const handleToggle = useCallback(() => setOpen((prev) => !prev), []);

  if (!plan) return null;

  return (
    <Box id={CURRENT_PLAN_BANNER_ID}>
      <Box className={classnames('CurrentPlanBanner', className)} sx={SX.root}>
        <CurrentPlanHeader plan={plan} open={open} onToggle={handleToggle} />
        <Collapse in={open} unmountOnExit>
          <Box sx={SX.body}>
            <CurrentPlanSummary plan={plan} />
            <CurrentPlanInclusion plan={plan} />
          </Box>
        </Collapse>
      </Box>
    </Box>
  );
});

CurrentPlanBanner.displayName = 'CurrentPlanBanner';
